import {gql} from '@apollo/client';

export const contactQueries = {
    GET_CONTACTS: gql`
        query Contacts {
            contacts {
                nodes {
                    id
                    objectId
                    objectType
                    type
                    value
                }
            }
        }
    `,
    GET_CONTACTS_BY_IDS: gql`
        query ContactsByIds($ids: [UUID!]!) {
            contactsByIds(ids: $ids) {
                id
                objectId
                objectType
                type
                value
            }
        }
    `,
    GET_CONTACTS_BY_OBJECT_ID_AND_OBJECT_TYPE: gql`
        query ContactsByObjectIdAndObjectType($objectId: UUID!, $objectType: String!) {
            contactsByObjectIdAndObjectType(objectId: $objectId, objectType: $objectType) {
                id
                objectId
                objectType
                type
                value
            }
        }
    `,
};
